<template>
  <a-form :form="form" @submit.prevent="onSubmit" layout="vertical">
    <a-form-item v-bind="errorsBind('non_field_errors')" />

    <a-row :gutter="16" type="flex" class="c-form-row">
      <a-col :span="24">
        <form-heading class="mt-4">Podstawowe informacje:</form-heading>
      </a-col>

      <a-col :span="14">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item
              label="Imię"
              v-bind="errorsBind('first_name')"
              required
            >
              <a-input
                v-model="form.first_name"
                auto-complete="off"
                placeholder="imię"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="Nazwisko"
              v-bind="errorsBind('last_name')"
              required
            >
              <a-input
                v-model="form.last_name"
                auto-complete="off"
                placeholder="nazwisko"
              >
              </a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="Email" v-bind="errorsBind('email')" required>
              <a-input
                type="email"
                v-model="form.email"
                auto-complete="off"
                placeholder="adres email"
              >
              </a-input>
              <form-hint v-if="!form.id">
                Na podany adres zostanie wysłany e-mail z linkiem do ustawienia
                hasła.
              </form-hint>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item
              label="Numer telefonu"
              v-bind="errorsBind('phone_number')"
            >
              <a-input
                v-model="form.phone_number"
                auto-complete="off"
                placeholder="Wpisz numer"
              >
              </a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6" :offset="2" class="mt-24">
        <avatar-input
          v-model="form.avatar"
          :currentUrl="form.avatar_preview"
          :action="avatarAction"
          @removeImage="form.avatar_preview = null"
        />
      </a-col>
    </a-row>

    <a-divider />

    <a-row :gutter="16" class="c-form-row">
      <a-col :span="24">
        <form-heading>Dodatkowe informacje:</form-heading>
      </a-col>

      <a-col :span="14">
        <a-form-item label="Certyfikaty" v-bind="errorsBind('certificates')">
          <certificates-input
            v-model="form.certificates"
            :errors="form.certificates || []"
            :action="certificatesAction"
          />
        </a-form-item>
      </a-col>

      <a-col :span="14">
        <a-form-item label="Wykształcenie" v-bind="errorsBind('education')">
          <a-input
            v-model="form.education"
            type="textarea"
            auto-complete="off"
            placeholder="Wpisz szkołę, lub certyfikat"
          >
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="14">
        <a-form-item label="Biografia" v-bind="errorsBind('bio')">
          <a-input
            type="textarea"
            v-model="form.bio"
            auto-complete="off"
            placeholder="Wpisz krótki opis lektora..."
          >
          </a-input>
        </a-form-item>
      </a-col>
    </a-row>

    <a-divider />

    <a-row :gutter="16" class="c-form-row">
      <a-col :span="24">
        <form-heading>Narzędzia komunikacyjne:</form-heading>
      </a-col>

      <a-col :span="14">
        <a-form-item label="Skype" v-bind="errorsBind('skype_username')">
          <a-input
            v-model="form.skype_username"
            placeholder="Wpisz nazwę użytkownika"
          >
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="14">
        <a-form-item
          label="Ustawienia powiadomień"
          v-bind="errorsBind('receive_email_notifications')"
        >
          <a-checkbox v-model="form.receive_email_notifications"
            >Powiadomienia wysyłane drogą mailową</a-checkbox
          >
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="16">
      <a-col :span="13">
        <a-row :gutter="16"> </a-row>
      </a-col>
    </a-row>

    <a-button type="primary" html-type="submit" :disabled="!isDirty">
      <span>Zapisz</span>
    </a-button>
  </a-form>
</template>

<script>
import FieldHelper from '@/components/common/forms/FieldsHelper'
import { Student } from '@/api'
import AvatarInput from '@/components/inputs/AvatarInput'
import CertificatesInput from '@/components/inputs/CertificatesInput'
import FormHint from '@/components/common/forms/FormHint'
import FormHeading from '@/components/common/forms/FormHeading'

export default {
  extends: FieldHelper,
  components: {
    AvatarInput,
    CertificatesInput,
    FormHint,
    FormHeading
  },
  computed: {
    avatarAction() {
      return Student.attachmentUploadUrl + '?attachment_name=avatar'
    },
    certificatesAction() {
      return Student.attachmentUploadUrl + '?attachment_name=certificate'
    }
  }
}
</script>

<style lang="scss" scoped></style>
